<template>
  <div class="modal-finances-table">
    <div
      class="labels row"
      :class="{
        'right-padding': this.hasScroll,
        'trashcan-padding': showTrashCan,
        'checkbox-padding': checkable
      }"
    >
      <div
        class="column"
        v-for="column in columns"
        :key="column.key"
        :style="{ flex: column.flex }"
      >{{ column.label }}</div>
    </div>
    <div ref="rows" class="rows" :style="{ 'max-height': height + 'px' }">
      <div
        class="row"
        v-for="row in data"
        :key="row.id"
        :class="{ 'emit-row': emitRowOnClick || checkable }"
        @click="handleRowClick(row)"
      >
        <div
          class="column"
          v-for="column in columns"
          :key="column.key"
          :style="{ flex: column.flex }"
        >
          <div v-if="shouldAddSeparator(column.key)">{{ row[column.key] | addSeparator }}</div>
          <div v-else>{{ row[column.key] | formatEmptyFields}}</div>
        </div>
        <i class="far fa-trash-alt trash--mod" v-if="showTrashCan" @click="$emit('remove', row)"></i>
        <checkbox
          size="small"
          :checked="row.checked"
          @change.native="row.checked = !row.checked"
          v-if="checkable"
        ></checkbox>
      </div>
      <!-- <div class="more-dots">
        <h3 v-if="count > 5">...</h3>
      </div>-->
    </div>
  </div>
</template>
<script>
import checkbox from '@/components/common/Checkbox.vue';
import { addSeparatorMixin, formatEmptyFieldsMixin } from '@/mixins/mixins.js';
export default {
  props: {
    columns: { type: Array, required: true },
    data: { type: Array, required: true },
    showTrashCan: { type: Boolean, required: false, default: false },
    emitRowOnClick: { type: Boolean, required: false, default: false },
    height: { requried: false },
    checkable: { type: Boolean, default: false }
  },
  created() {
    this.$nextTick(() => {
      if (this.$refs.rows.clientHeight < this.$refs.rows.scrollHeight) {
        this.hasScroll = true;
      }
    });
  },
  mixins: [addSeparatorMixin, formatEmptyFieldsMixin],
  components: {
    checkbox
  },
  watch: {
    data() {
      this.$nextTick(() => {
        if (this.$refs.rows.clientHeight < this.$refs.rows.scrollHeight) {
          this.hasScroll = true;
        } else {
          this.hasScroll = false;
        }
      });
    },
    getDataLength() {
      if (this.$refs.rows.clientHeight < this.$refs.rows.scrollHeight) {
        this.hasScroll = true;
      } else {
        this.hasScroll = false;
      }
    }
  },
  computed: {
    getDataLength() {
      return this.data.length;
    }
  },
  data() {
    return {
      count: 0,
      hasScroll: false
    };
  },
  methods: {
    handleRowClick(row) {
      if (this.checkable) {
        row.checked = !row.checked;
      } else if (this.emitRowOnClick) {
        this.$emit('rowClick', row);
      }
    },
    shouldAddSeparator(columnName) {
      switch (columnName) {
        case 'amount':
          return true;
        case 'price':
          return true;
        case 'total_amount':
          return true;
        case 'total':
          return true;
        default:
          return false;
      }
    }
  }
};
</script>
<style lang="scss">
.modal-finances-table {
  // max-height: calc(100% - 35px);
  // height: calc(100% - 35px);
  height: 100%;
  max-height: 100%;
  margin-bottom: 0;
  font-size: 0.9rem;
  position: relative;
  z-index: 0;

  .right-padding {
    .column:last-of-type {
      padding-right: 0.7rem;
    }
  }

  .trashcan-padding {
    padding-right: 3rem;
  }

  .checkbox-padding {
    padding-right: 2.1rem;
  }

  .rows {
    max-height: calc(100% - 22px);
    overflow-y: auto;
    // padding: 0.5rem 0;

    .row:nth-child(2n) {
      background-color: rgba(0, 0, 0, 0.05);
    }

    .row:hover {
      background-color: rgba(0, 0, 0, 0.178);
    }

    .emit-row {
      cursor: pointer;
    }

    // .row:hover .trash--mod {
    //   display: none;
    // }
    .row {
      padding: 3px 0;
      height: 15%;
      width: 100% !important;
      display: flex;
      .column {
        text-align: left;
        flex: 1;
        word-break: break-word;
        display: flex;
        align-items: center;
      }

      .trash--mod {
        padding-right: 5px;
        margin: auto 0;
        transition: 0.2s all;
        margin-left: 1.8rem;
      }

      .trash--mod:hover {
        color: red;
        cursor: pointer;
      }

      .checkbox {
        margin: auto 0;
        margin-right: 20px;
      }

      .checkbox:hover {
        cursor: pointer;
      }
    }
  }
  .labels {
    border-bottom: 1px solid gray;
    .column {
      font-weight: 600;
    }
  }
  .more-dots {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 10%;
    width: 100%;
    h3 {
      font-size: 3rem;
      margin-top: -36px;
      text-align: center;
    }
  }
}
</style>
